import { fromJS, Map } from 'immutable';
import { listToMap } from 'flow/utils';
import {
    getWallboardWithSettingsCastToProperDataTypes,
    getWallboardsWithSettingsCastToProperDataTypes,
} from 'flow/utils/wallboard-utils';
import Actions from 'flow/actions';

const initialState = fromJS({
    wallboards: new Map(),
    hasAccess: false,
});

export const wallboardsReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_WALLBOARDS: {
            const wallboards = getWallboardsWithSettingsCastToProperDataTypes(
                fromJS(action.data),
            );
            return state.set(
                'wallboards',
                listToMap(wallboards, (e) => e.get('key')),
            );
        }
        case Actions.RESULT_WALLBOARD_CREATED: {
            const wallboard = getWallboardWithSettingsCastToProperDataTypes(
                fromJS(action.data),
            );
            return state.setIn(['wallboards', wallboard.get('key')], wallboard);
        }
        case Actions.RESULT_WALLBOARD_UPDATED: {
            const wallboard = getWallboardWithSettingsCastToProperDataTypes(
                fromJS(action.data),
            );
            const wallboardKey = action.key;
            return state.updateIn(['wallboards', wallboardKey], Map(), (prev) =>
                prev.merge(wallboard),
            );
        }
        case Actions.RESULT_WALLBOARD_REGENERATED: {
            const wallboard = getWallboardWithSettingsCastToProperDataTypes(
                fromJS(action.data),
            );
            return state.setIn(['wallboards', action.key], wallboard);
        }
        case Actions.RESULT_WALLBOARD_DELETED: {
            const wallboardKey = action.key;
            return state.deleteIn(['wallboard', wallboardKey]);
        }
        case Actions.SET_WALLBOARD_ACCESS: {
            return state.set('hasAccess', action.access);
        }
        default: {
            return state;
        }
    }
};

export default wallboardsReducer;
